import script from "./CardInformacionExperiencia.vue?vue&type=script&setup=true&lang=js"
export * from "./CardInformacionExperiencia.vue?vue&type=script&setup=true&lang=js"

import "./CardInformacionExperiencia.vue?vue&type=style&index=0&id=641ae51f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-641ae51f"]])

export default __exports__